import {
  HTTP_INTERCEPTORS,
  HttpContextToken,
  HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { Provider, inject } from '@angular/core';
import { AnalyticsService } from '../services/analytics.service';
import { ToastService } from '../components/toast/toast.service';
import { ErrorResponse } from './error-response.model';

export const IGNORED_ERROR_STATUSES = new HttpContextToken<number[]>(() => []);

export class MonitoringInterceptor implements HttpInterceptor {
  analytics: AnalyticsService;
  toast: ToastService;

  constructor() {
    this.analytics = inject(AnalyticsService);
    this.toast = inject(ToastService);
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(req.clone()).pipe(catchError((e: HttpErrorResponse) => this.handleError(req, e)));
  }

  private handleError(req: HttpRequest<unknown>, e: ErrorResponse) {
    const ignoredStatuses = req.context.get(IGNORED_ERROR_STATUSES);
    if (e instanceof HttpErrorResponse && ignoredStatuses.includes(e.status)) {
      return throwError(() => e);
    }

    const request = { url: req.url, method: req.method };
    const response = { status: e.status, error: e.error || e.message };

    if (e instanceof HttpErrorResponse) {
      this.analytics.error(e.status, request, response);
    } else {
      this.analytics.error(500, request, response);
    }

    this.reportError(e);

    return throwError(() => e);
  }

  reportError(response: ErrorResponse) {
    try {
      if (!response?.error) throw new Error('Erro não tratado.');
      const { code, detail } = response.error;
      if (!detail || !code) throw new Error('Erro não tratado, detail ou code são inválidos.');

      this.toast.failure(detail);
      return;
    } catch (error) {
      this.toast.failure('Ocorreu um erro inesperado.');
    }
  }
}

export const monitoringInterceptorProvider: Provider = {
  provide: HTTP_INTERCEPTORS,
  multi: true,
  useClass: MonitoringInterceptor,
};
